import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import reducers from "./reducers";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

function getRehydratedLogin() {
  try {
    const saved = sessionStorage.getItem("login");
    if (!saved) return null;
    return JSON.parse(saved);
  } catch {
    return null;
  }
}

export function rehydrateLogin(reduxStore = store) {
  const login = getRehydratedLogin();
  if (login) {
    reduxStore.dispatch({ type: "FETCH_LOGIN", payload: login });
  }
}

export const store = createStore(
  reducers,
  composeEnhancers(applyMiddleware(thunk)),
);

rehydrateLogin(store);